export default {
  updateOptionsComment(state, val) {
    state.optionsComment = val;
  },

  // TODO: deprecated
  updateOptions(state, val) {
    state.optionsList[val.index].option_default = val.value;
  },

  updateOptionItemCustomizer(state, { name, code_1c, value }) {
    const index = state.optionsList.findIndex(el =>
      code_1c ? el.code_1c === code_1c : el.name === name,
    );

    if (index !== -1) {
      state.optionsList[index].option_default = value;
    }
  },

  updateIsDisabledDlypr(state, isVal = false) {
    state.isDisabledDlypr = isVal;
  },

  updateOptionsErrors(state, val) {
    if (val.inBasket !== undefined) {
      state.optionsErrors.inBasket = val.inBasket;
    }

    if (val.calculate !== undefined) {
      state.optionsErrors.calculate = val.calculate;
    }
  },

  updateOptionsList(state, val) {
    state.optionsList = val;
    state.optionsListOriginal = val;
  },

  updateOptionsListData(state, val) {
    state.optionsList = JSON.parse(JSON.stringify(val));
  },

  updateOptionsListOriginal(state, val) {
    state.optionsListOriginal = val;
  },

  updateOptionsCount(state) {
    state.optionsCount = 0;
    if (state.optionsList && state.optionsListOriginal) {
      for (let i = 0; i < state.optionsList.length; i++) {
        if (
          state.optionsList[i].option_default !== null &&
          state.optionsList[i].option_default !== state.optionsListOriginal[i].option_default
        ) {
          state.optionsCount++;
        }
      }
    }
  },

  updateOptionWarning(state, val) {
    state.optionWarning.value = val ? val.value : null;
    state.optionWarning.index = val ? val.index : null;
  },
};
